import {
  UNDEFINED_CHECKOUT_TOKEN,
  UNDEFINED_CHECKOUT_USER_ID,
  getCheckoutLocaleCookie,
  getCheckoutToken,
  setCheckoutLocaleCookie,
  setCheckoutTokenHandoffCookie,
  setCheckoutUserIdCookie,
} from "./index";
import { parseLocale } from "@/i18n";

export interface CheckoutHandoffCookieParams {
  customerId?: string | null;
  locale?: string | null;
  checkoutToken?: string | null;
}

/**
 * Writes checkout auth cookies on the shared Tamara parent domain so sibling
 * apps (questionnaire-ui, KYC) can read them after a full-page redirect.
 *
 * Legacy checkout-ui set `tamara-checkout-user-id` during OTP; PPUI must do
 * the same for Flutter WebView flows that skip that step.
 */
export function syncCheckoutHandoffCookies(
  params: CheckoutHandoffCookieParams = {},
): void {
  const customerId = params.customerId?.trim();
  if (customerId && customerId !== UNDEFINED_CHECKOUT_USER_ID) {
    setCheckoutUserIdCookie(customerId);
  }

  const token = (params.checkoutToken ?? getCheckoutToken())?.trim();
  if (token && token !== UNDEFINED_CHECKOUT_TOKEN) {
    setCheckoutTokenHandoffCookie(token);
  }

  const locale =
    parseLocale(params.locale ?? undefined) ??
    parseLocale(getCheckoutLocaleCookie() ?? undefined) ??
    parseLocale(getCheckoutLocaleFromUrl());
  if (locale) {
    setCheckoutLocaleCookie(locale);
  }
}

function getCheckoutLocaleFromUrl(): string | undefined {
  try {
    return new URLSearchParams(window.location.search).get("locale") ?? undefined;
  } catch {
    return undefined;
  }
}
